import PropTypes from 'prop-types';

// Simplified: MUI theme localization removed, just pass children through
ThemeLocalization.propTypes = {
  children: PropTypes.node,
};

export default function ThemeLocalization({ children }) {
  return <>{children}</>;
}
